import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import ProcessContext from '../contexts/process/ProcessContext';
import UIContext from '../contexts/ui/UIContext';
import Button from './layout/Button';
import AuthContext from '../contexts/auth/AuthContext';

const StatusBar = () => {
	const { activeProcessId, taskData, finishProcess } = useContext(ProcessContext);
	const { userInformation } = useContext(AuthContext);
	const { loading } = useContext(UIContext);

	const navigate = useNavigate();

    const resetAll = async () => {

    if (activeProcessId) {
           await finishProcess();
    }
        if (taskData) {
            if (taskData?.redirectUrl) {
                window.location.href = taskData.redirectUrl;
                return;
            }
            navigate('/', { state: { slide: 1 } });
            return;
        };

		navigate('/');
	};

	return (
		<div className='sweden-status-bar'>
			<div className='status-slider'></div>
			<div className='status-btn-1'></div>
			<div className='status-btn-2'></div>
			<div className='status-btn-3'>
				{!userInformation && (
					<div className='status-links'>
						<a href='https://suiteg.de/imprint.html' target='_blank' rel='noreferrer'>
							Legal Notice
						</a>
						<i>-</i>
						<a href='https://suiteg.de/data-privacy.html' target='_blank' rel='noreferrer'>
							Data Privacy
						</a>
					</div>
				)}
				{activeProcessId && <Button label='Abort' type='inline' className='reset-btn' icon='fas fa-ban' disabled={loading} clickHandler={resetAll} />}
			</div>
			<div className='status-btn-4'></div>
			<div className='status-btn-5'></div>
		</div>
	);
};

export default StatusBar;
